module.exports = __webpack_public_path__ + "static/media/fr-tracing-shot-3.c5e5249a.png";